export const state = () => ({
  items: [],
  total: null,
  perPage: 20,
  page: 1,
  lastPage: 1,
  orderBy: 'created_at',
  orderDirection: 'desc',
  api: '/api/v1/items'
})
export const getters = {
  getItemById(state) {
    return (itemId) => state.items.find(item => item.id === itemId)
  },
  getItemByUuId(state) {
    return (itemUuid) => state.items.find(item => item.uuid === itemUuid)
  },
  getItems(state) {
    return state.items
  }
}

export const actions = {
  itemPatchState(item) {
    const index = this.items.findIndex(itemLoop => itemLoop.id === item.id)
    if (index > -1) {
      this.items.splice(index, 1, item)
    } else {
      this.items.push(item)
    }
  },
  itemRemoveFromState(itemId) {
    const index = this.items.findIndex(itemLoop => itemLoop.id === itemId)
    if (index > -1) {
      this.items.splice(index, 1)
    }
  },
  async fetchItemById(itemId) {
    const { data } = await axios.get(`${this.api}/${itemId}`)
    this.itemPatchState(data)
    return data
  },
  async fetchItems(params) {
    const { data } = await axios.get(this.api,{
      params: params
    })
    if(params && params.clear) {
      this.items = data.data
    }
    else {
      for (const item of data.data) {
        this.itemPatchState(item)
      }
    }

    this.page = data.current_page
    this.perPage = data.per_page
    this.total = data.total
    this.lastPage = data.last_page

    return data
  },
  async itemCreate(payload) {
    const { data } = await axios.post(this.api, payload)
    this.itemPatchState(data)
    return data
  },
  async itemPatch(payload) {
    const { data } = await axios.patch(this.api + '/' + payload.id, payload)
    this.itemPatchState(data)
    return data
  },
  async itemDelete(itemId) {
    const { data } = await axios.delete(this.api + '/' + itemId)
    this.itemRemoveFromState(itemId)
    return data
  },
  async itemRestore(itemId) {
    const { data } = await axios.post(this.api + '/' + itemId + '/restore')
    this.itemPatchState(data)
    return data
  },
  clearItems() {
    this.items = []
  }
}
